import { Action, ThunkAction, applyMiddleware, getDefaultMiddleware } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './rootReducer';
import { rootSaga } from './sagas';
import { configureStore } from '@reduxjs/toolkit'
import { NAV_STORAGE_KEY } from '../features/navigation/navigationSlice';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
  reducer: rootReducer,
  middleware: [
    ...getDefaultMiddleware({ thunk: false, serializableCheck: false }),
    sagaMiddleware,
  ],
  devTools: process.env.NODE_ENV !== 'production',
})
// export const store = createStore(
//   rootReducer,
//   applyMiddleware(sagaMiddleware)
//   // devTools: process.env.NODE_ENV !== 'production',
// );

sagaMiddleware.run(rootSaga);

// Persist the current navigation location to localStorage so a refresh restores it.
let lastPersistedNav: unknown;
store.subscribe(() => {
  const loc = store.getState().navigation.current;
  if (loc !== lastPersistedNav) {
    lastPersistedNav = loc;
    try { localStorage.setItem(NAV_STORAGE_KEY, JSON.stringify(loc)); } catch { /* ignore */ }
  }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export default store;
